import { $t } from '@/i18n';
import compose from 'koa-compose';
import { remove } from 'lodash';
const middlewares = [];
export function registerMiddleware(middleware, type = MiddlewareTypes.SERVER) {
    if (middlewares.some(item => item.middleware === middleware)) {
        throw new Error($t('k_b7b02562'));
    }
    const config = {
        middleware,
        type,
    };
    middlewares.push(config);
    return () => {
        remove(middlewares, config);
    };
}
;
export async function requestWithMiddlewares(ctx, rawRequest) {
    const serverMiddlewares = middlewares
        .filter(item => [MiddlewareTypes.ALL, MiddlewareTypes.SERVER].includes(item.type))
        .map(item => item.middleware);
    const request = compose(serverMiddlewares);
    const requestor = async () => {
        try {
            ctx.response = await rawRequest();
        }
        catch (error) {
            if (error?.response) {
                ctx.response = error?.response;
                error.message += `. ${error?.response?.data?.message}`;
            }
            throw error;
        }
    };
    await request(ctx, requestor);
    return ctx.response;
}
export var MiddlewareTypes;
(function (MiddlewareTypes) {
    MiddlewareTypes["ALL"] = "all";
    MiddlewareTypes["SERVER"] = "server";
    MiddlewareTypes["FRONT_END"] = "frontEnd";
})(MiddlewareTypes || (MiddlewareTypes = {}));
